/** Panneau formulaire 640px — Figma wizard Step 1–2 (2482-24965) */
const WasteFlowFormPanel = ({ title, children }) => (
  <div className="waste-flow-form-panel rounded-lg">
    <div className="waste-flow-form-panel__header">
      <h3 className="waste-flow-form-panel__title">{title}</h3>
    </div>
    <div className="waste-flow-form-panel__body">{children}</div>
  </div>
);

export default WasteFlowFormPanel;
